import { render, staticRenderFns } from "./EditModuleDialog.vue?vue&type=template&id=28856c89&scoped=true&"
import script from "./EditModuleDialog.vue?vue&type=script&lang=js&"
export * from "./EditModuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28856c89",
  null
  
)

export default component.exports